import { render, staticRenderFns } from "./AddPassengerToPassengerGroupForm.vue?vue&type=template&id=d5cb7b0e"
import script from "./AddPassengerToPassengerGroupForm.vue?vue&type=script&lang=ts"
export * from "./AddPassengerToPassengerGroupForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports